<style lang="stylus">

.delay-info {
  background-color: #fff;
  margin-bottom: 10px;
  height: 75px;
  padding: 12px 15px 15px 15px;
  display: flex;

  .delay-icon {
    line-height 54px
    margin-right 15px
    display: flex;
    align-items: center;
    img{
        width 26px;
    }
  }

  .delay-detail {
    width: 80%;


    .delay-numb {
      font-size 18px;
    }

    .delay-date {
      color: rgb(121, 125, 130);
      font-size: 13px
      margin-top: 2px;
    }
  }
}
</style>
<template>
  <div class="delay-info">
    <div class="delay-icon">
      <img src="../../../../image/preorder/cardInfo.png" />
    </div>
    <div class="delay-detail">
      <div class="delay-numb">{{ delayInfo.cardNum }}</div>
      <div class="delay-date">原有效期{{ delayInfo.startDate }}至{{ delayInfo.endDate }}</div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import _ from 'underscore'
import moment from 'moment'
export default {
  props: [],

  data() {
    return {}
  },
  methods: {},
  computed: {
    ...mapState({
      initInfo: state => state.preorder.orderInitInfo, //普通订单数据
    }),
    delayInfo() {
      //如果是其他store中没有，就取传递过来的CardData
      const a = this.initInfo[0] == undefined ? this.cardData : this.initInfo
      if (a[0] != undefined) {
        return {
          startDate: moment.unix(a[0].startDate).format('YYYY-MM-DD'),
          endDate: moment.unix(a[0].endDate).format('YYYY-MM-DD'),
          cardNum: a[0].cardNum,
        }
      } else {
        return {
          startDate: '1970-01-01',
          endDate: '1970-01-01',
          cardNum: '123456',
        }
      }
    },
  },
  components: {},
  props: ['cardData'],
}
</script>
